import styled from 'styled-components'

const StyledCaptionLibrary = styled.div`
  width: 100%;
`

export default StyledCaptionLibrary
